import { render, staticRenderFns } from "./BaseListPage.vue?vue&type=template&id=471efe2f"
import script from "./BaseListPage.vue?vue&type=script&lang=js"
export * from "./BaseListPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports